import ParameterFieldBase, { IParameterFieldBaseOptions, IValidator } from './ParameterFieldBase';
import EditComponent, { IBooleanFieldOptions } from '../tsx/BooleanField';

export default class BooleanField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];
    public static EditComponent = EditComponent;

    public getDefaultOptions() {
        return {
            noTitle: true
        };
    }

    constructor(
        glob,
        title: string,
        validators?: IValidator[],
        defaultVal?: ((args) => boolean) | boolean,
        options?,
        directionOptions?: IBooleanFieldOptions
    ) {
        //BooleanField has no title as ParameterField, but has a label to the right of the checkbox.
        //That's why noTitle is set and title parameter is put to options.
        options = Object.assign(
            {
                title: title
            },
            options
        );

        super(
            glob,
            title,
            BooleanField.defaultValidators,
            validators,
            (defaultVal = defaultVal == null ? false : defaultVal),
            options,
            directionOptions
        );
    }
}
